import { createTheme } from '@mui/material/styles';
import { UNIVERSAL_THEME_ELEMENTS } from './universal-theme-elements';
import '../theme-augmentations';

export const COLOR_BLIND_MODE = createTheme({
  ...UNIVERSAL_THEME_ELEMENTS,
  palette: {
    text: {
      primary: '#550000',
    },
    primary: {
      main: '#550000',
      contrastText: '#fff',
    },
  },
});
